<button
  class="ui-chip"
  type="button"
  [class.ui-chip-active]="active()"
  [class.ui-chip-primary]="isPrimary()"
  [class.ui-chip-success]="isSuccess()"
  [class.ui-chip-warning]="isWarning()"
  [class.ui-chip-danger]="isDanger()"
  [disabled]="disabled()"
  [attr.aria-pressed]="selectable() ? active() : null"
  (click)="handleClick($event)"
>
  <span class="ui-chip-content">
    <ng-content />
  </span>
</button>
